/* eslint-disable @next/next/no-html-link-for-pages */
import {
  Text,
  Input,
  Button,
  Checkbox,
  Stack,
  Center,
  Box,
  Link,
} from "@chakra-ui/react";
import React, { useState, useCallback, useEffect } from "react";
import BaseLayout from "../../../components/en/index_layout";
import { signUp } from "../../../provider/auth";
import { SetToken, SetCookie } from "../../../provider/common";
export default function SignUp() {
  const [email, setEmail] = useState("");
  const [password1, setPassword1] = useState("");
  const [password2, setPassword2] = useState("");
  const [name, setName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isAgree, setIsAgree] = useState(0);
  const [emailHidden, setEmailHidden] = useState(true);
  const [nameHidden, setNameHidden] = useState(true);
  const [passwordHidden, setPasswordHidden] = useState(true);
  const [agreedHidden, setAgreedHidden] = useState(true);
  const [checkMatchPass, setCheckMatchPass] = useState(true);

  useEffect(() => {
    if (password1 !== password2) {
      setCheckMatchPass(false);
    } else {
      setCheckMatchPass(true);
    }
  }, [password2]);

  const _handleChange = useCallback((e) => {
    const { name, value } = e.target;
    switch (name) {
      case "name":
        setName(value);
        break;
      case "email":
        setEmail(value);
        몃;
        break;
      case "password1":
        setPassword1(value);
        break;
      case "password2":
        setPassword2(value);
        break;
      case "companyName":
        setCompanyName(value);
        break;
    }
  });

  // 동의박스
  const handleAgree = useCallback((e) => {
    let checked = e.target.checked;

    // 체크되어있으면 추가
    if (checked === true) {
      setIsAgree(1);
    } else {
      setIsAgree(0);
    }
  });

  // 로그인 버튼 함수
  const _handleSubmit = async () => {
    setNameHidden(true);
    setPasswordHidden(true);
    setEmailHidden(true);

    //로그인 검증하는 로딩하는 부분 띄우기
    //중복 클릭 방지등
    setIsLoading(true);
    //로그인 빈칸 검증
    // && password1 !== "" && password2 !== "" && email !== "" && isAgree === 1
    switch ("") {
      case email:
        setEmailHidden(false);
        return;
      case password1:
        setPasswordHidden(false);
        return;
      case password2:
        setPasswordHidden(false);
        return;
      case name:
        setNameHidden(false);
        return;
    }
    if (isAgree === 0) {
      setAgreedHidden(false);
      return;
    }
    //비밀번호가 2개가 같은지 검증띄우기
    if (password1 !== password2) {
      alert("The passwords do not match.");
      return false;
    }

    // 회원가입 통신
    const auth = await signUp(
      email.trim(),
      password1.trim(),
      name.trim(),
      companyName.trim()
    );
    if (!auth) {
      return;
    }

    if (auth.status === 201) {
      setIsLoading(true);
      SetToken(auth.access_token);
      SetCookie("isLogin", 1);
      window.location.replace("/board/register");
    } else {
      setIsLoading(false);
      alert(auth.msg);
    }
  };
  const keyPressRegister = (e) => {
    if (e.key === "Enter") {
      _handleSubmit();
    }
  };
  return (
    <BaseLayout>
      <Box className="base_container" w="400px!important" marginBottom={20}>
        <Stack spacing={1} marginTop={20}>
          <Text>Email *</Text>
          <Input
            variant="outline"
            placeholder="example@pandaparts.co.kr"
            name="email"
            padding="6"
            color="#333"
            onChange={_handleChange}
            onKeyPress={keyPressRegister}
          />
        </Stack>
        {emailHidden ? "" : <Box color="red">Please enter your email.</Box>}
        <Stack spacing={1} marginTop={5}>
          <Text>Password *</Text>
          <Input
            variant="outline"
            placeholder="Please enter your password."
            name="password1"
            padding="6"
            color="#333"
            type="password"
            onChange={_handleChange}
            onKeyPress={keyPressRegister}
          />
          {passwordHidden ? (
            ""
          ) : (
            <Box color="red">Please enter your password.</Box>
          )}
        </Stack>
        <Stack spacing={1} marginTop={5}>
          <Text>Confirm Password *</Text>
          <Input
            variant="outline"
            placeholder="Please enter your password again."
            name="password2"
            padding="6"
            color="#333"
            type="password"
            onChange={_handleChange}
            onKeyPress={keyPressRegister}
            className={checkMatchPass ? "" : "border-red"}
          />
          {passwordHidden ? (
            ""
          ) : (
            <Box color="red">Please enter your password.</Box>
          )}
        </Stack>
        <Stack spacing={1} width={400} marginTop={5}>
          <Text>Name *</Text>
          <Input
            variant="outline"
            name="name"
            placeholder="Please enter your name."
            marginTop="2"
            padding="6"
            color="#333"
            onChange={_handleChange}
            onKeyPress={keyPressRegister}
          />
          {nameHidden ? "" : <Box color="red">Please enter your name.</Box>}
        </Stack>
        <Stack spacing={1} marginTop={5}>
          <Text>Company</Text>
          <Input
            variant="outline"
            placeholder="Please enter your company."
            name="companyName"
            padding="6"
            color="#333"
            onChange={_handleChange}
            onKeyPress={keyPressRegister}
          />
        </Stack>

        <Checkbox
          size="md"
          colorScheme="red"
          marginRight="5"
          borderColor="gray.300"
          paddingTop="3"
          value={isAgree}
          onChange={handleAgree}
        >
          By signing up, I agree to{" "}
          <a
            href="/en/board/home?status=Terms"
            className="link"
            target="_blank"
            rel="noopener noreferrer"
            style={{ marginRight: "3.5px", display: "inline-block" }}
          >
            the Terms of Service
          </a>
          {""}and{""}
          <a
            href="/en/board/home?status=Privacy"
            className="link"
            target="_blank"
            rel="noopener noreferrer"
            style={{ marginLeft: "3.5px", display: "inline-block" }}
          >
            Privacy Policy
          </a>
        </Checkbox>
        {agreedHidden ? (
          ""
        ) : (
          <Box color="red">Please agree to the terms of service.</Box>
        )}
        <Stack spacing={4} direction="row" align="center">
          <Button
            colorScheme="red"
            size="lg"
            width="100%"
            padding="6=7"
            marginTop={5}
            fontSize="16"
            letterSpacing="-1px"
            onClick={_handleSubmit}
            onKeyPress={keyPressRegister}
          >
            Create an account{" "}
          </Button>
        </Stack>
        <Center bg="fff" h="50" color="000">
          Already have an account?
          <Link href="/en/auth/login" className="link">
            <Text> &nbsp;Sign In</Text>
          </Link>
        </Center>

        {/* <Center bg="fff" h="50" color="000">
          SNS 계정으로 가입
        </Center>

        <Wrap spacing="1" justify="center" marginBottom={20}>
          <WrapItem>
            <Center w="60px" h="60px" bg="fff">
              <img
                boxSize="30px"
                objectFit="cover"
                src="/images/snslogin_naver.png"
                alt="Segun Adebayo"
              />
            </Center>
          </WrapItem>
          <WrapItem>
            <Center w="60px" h="60px" bg="fff">
              <img
                boxSize="30px"
                objectFit="cover"
                src="/images/snslogin_kakao.png"
                alt="Segun Adebayo"
              />
            </Center>
          </WrapItem>
        </Wrap> */}
      </Box>
    </BaseLayout>
  );
}
